<script setup>
import {useWindowSize} from "@vueuse/core";
import {ref} from "vue";
import Dialog from "primevue/dialog";

defineProps({
    title: String,
    icon: String
})

const {width} = useWindowSize()

const visible = ref(false);

</script>

<template>
    <div
        v-if="width > 768"
        class="settings-panel flex flex-col gap-3 items-center border-b dark:border-gray-800 p-6 pt-4 bg-white dark:bg-gray-900 rounded-xl shadow-md hover:shadow-lg transition-shadow"
    >
        <label
            class="title text-sm font-medium text-gray-700 dark:text-gray-200"
            for="theme.color"
        >
            {{ title }}
        </label>
        <slot></slot>
    </div>
    <div v-else>
        <div
            class="action-card group transition-all rounded-xl cursor-pointer backdrop-blur-lg shadow-lg flex flex-col items-center gap-3 p-2 py-4 m-2 text-center border border-gray-200 dark:border-neutral-700 bg-white/90 dark:bg-gray-800 hover:scale-105 hover:shadow-2xl hover:border-blue-400 dark:hover:border-blue-600"
            style="width: 140px; overflow: hidden;"
            @click="visible = true"
        >
            <div
                class="icon-wrapper flex items-center justify-center rounded-full w-12 h-12 bg-blue-50 dark:bg-blue-900 text-roori-blue dark:text-blue-300 transition-transform group-hover:scale-110"
            >
                <i :class="icon" style="font-size: 1.25rem;"></i>
            </div>
            <p class="title text-xs font-semibold text-gray-700 dark:text-gray-200 transition-colors group-hover:text-roori-blue dark:group-hover:text-blue-300">
                {{ title }}
            </p>
        </div>
        <Dialog v-model:visible="visible" :header="title">
            <slot></slot>
        </Dialog>
    </div>
</template>

<style scoped lang="scss">
.settings-panel {
    background: var(--surface-card);
    border-radius: 12px;
    transition: all 0.3s ease-in-out;

    &:hover {
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
    }

    .title {
        color: var(--text-color);
        font-size: 0.875rem;
        font-weight: 600;
        margin-bottom: 0.5rem;
        text-align: center;
        transition: color 0.3s ease;

        &:hover {
            color: var(--primary-color);
        }
    }

    slot {
        width: 100%;
        display: flex;
        justify-content: center;
    }
}
</style>
